import { defineComponent as K, ref as y, toRef as I, provide as L, computed as _, h as T } from "vue";
import { radioGroupInjectionKey as M } from "./ghl-ui.es1105.js";
import q from "./ghl-ui.es1108.js";
import { useRtl as J } from "./ghl-ui.es875.js";
import Q from "./ghl-ui.es901.js";
import W from "./ghl-ui.es878.js";
import E from "./ghl-ui.es879.js";
import X from "./ghl-ui.es726.js";
import { createKey as x } from "./ghl-ui.es404.js";
import { useThemeClass as Y } from "./ghl-ui.es881.js";
import { flatten as Z } from "./ghl-ui.es956.js";
import { getSlot as oo } from "./ghl-ui.es1109.js";
import { warn as eo } from "./ghl-ui.es877.js";
import to from "./ghl-ui.es1107.js";
import { call as S } from "./ghl-ui.es907.js";
function no(o, a, e) {
  var u;
  const t = [];
  let l = !1;
  for (let s = 0; s < o.length; ++s) {
    const d = o[s], i = (u = d.type) === null || u === void 0 ? void 0 : u.name;
    if (i === "RadioButton" && (l = !0), process.env.NODE_ENV !== "production" && l && i !== "RadioButton") {
      eo("radio-group", "`n-radio-group` in button mode only takes `n-radio-button` as children.");
      continue;
    }
    const f = d.props;
    if (i !== "RadioButton") {
      t.push(d);
      continue;
    }
    if (s === 0)
      t.push(d);
    else {
      const b = t[t.length - 1].props, g = a === b.value, m = b.disabled, h = a === f.value, p = f.disabled, C = (g ? 2 : 0) + (m ? 0 : 1), B = (h ? 2 : 0) + (p ? 0 : 1), F = {
        [`${e}-radio-group__splitor--disabled`]: m,
        [`${e}-radio-group__splitor--checked`]: g
      }, V = {
        [`${e}-radio-group__splitor--disabled`]: p,
        [`${e}-radio-group__splitor--checked`]: h
      }, v = C < B ? V : F;
      t.push(T("div", {
        class: [`${e}-radio-group__splitor`, v]
      }), d);
    }
  }
  return {
    children: t,
    isButtonGroup: l
  };
}
const ro = Object.assign(Object.assign({}, E.props), {
  name: String,
  value: [String, Number, Boolean],
  defaultValue: {
    type: [String, Number, Boolean],
    default: null
  },
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array]
}), Bo = K({
  name: "RadioGroup",
  props: ro,
  setup(o) {
    const a = y(null), {
      mergedSizeRef: e,
      mergedDisabledRef: u,
      nTriggerFormChange: t,
      nTriggerFormInput: l,
      nTriggerFormBlur: s,
      nTriggerFormFocus: d
    } = Q(o), {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: f,
      mergedRtlRef: b
    } = W(o), g = E("Radio", "-radio-group", q, to, o, i), m = y(o.defaultValue), h = I(o, "value"), p = X(h, m);
    function C(n) {
      const {
        onUpdateValue: r,
        "onUpdate:value": R
      } = o;
      r && S(r, n), R && S(R, n), m.value = n, t(), l();
    }
    function B(n) {
      const {
        value: r
      } = a;
      r && (r.contains(n.relatedTarget) || d());
    }
    function F(n) {
      const {
        value: r
      } = a;
      r && (r.contains(n.relatedTarget) || s());
    }
    L(M, {
      mergedClsPrefixRef: i,
      nameRef: I(o, "name"),
      valueRef: p,
      disabledRef: u,
      mergedSizeRef: e,
      doUpdateValue: C
    });
    const V = J("Radio", b, i), v = _(() => {
      const {
        value: n
      } = e, {
        common: {
          cubicBezierEaseInOut: r
        },
        self: {
          buttonBorderColor: R,
          buttonBorderColorActive: w,
          buttonBorderRadius: z,
          buttonBoxShadow: $,
          buttonBoxShadowFocus: D,
          buttonBoxShadowHover: G,
          buttonColor: U,
          buttonColorActive: k,
          buttonTextColor: A,
          buttonTextColorActive: N,
          buttonTextColorHover: H,
          opacityDisabled: O,
          [x("buttonHeight", n)]: P,
          [x("fontSize", n)]: j
        }
      } = g.value;
      return {
        "--n-font-size": j,
        "--n-bezier": r,
        "--n-button-border-color": R,
        "--n-button-border-color-active": w,
        "--n-button-border-radius": z,
        "--n-button-box-shadow": $,
        "--n-button-box-shadow-focus": D,
        "--n-button-box-shadow-hover": G,
        "--n-button-color": U,
        "--n-button-color-active": k,
        "--n-button-text-color": A,
        "--n-button-text-color-hover": H,
        "--n-button-text-color-active": N,
        "--n-height": P,
        "--n-opacity-disabled": O
      };
    }), c = f ? Y("radio-group", _(() => e.value[0]), v, o) : void 0;
    return {
      selfElRef: a,
      rtlEnabled: V,
      mergedClsPrefix: i,
      mergedValue: p,
      handleFocusout: F,
      handleFocusin: B,
      cssVars: f ? void 0 : v,
      themeClass: c == null ? void 0 : c.themeClass,
      onRender: c == null ? void 0 : c.onRender
    };
  },
  render() {
    var o;
    const {
      mergedValue: a,
      mergedClsPrefix: e,
      handleFocusin: u,
      handleFocusout: t
    } = this, {
      children: l,
      isButtonGroup: s
    } = no(Z(oo(this)), a, e);
    return (o = this.onRender) === null || o === void 0 || o.call(this), T("div", {
      onFocusin: u,
      onFocusout: t,
      ref: "selfElRef",
      class: [`${e}-radio-group`, this.rtlEnabled && `${e}-radio-group--rtl`, this.themeClass, s && `${e}-radio-group--button-group`],
      style: this.cssVars
    }, l);
  }
});
export {
  Bo as default,
  ro as radioGroupProps
};
